(() => {
  const SELECTOR = '.koro-nav-shell';

  function setup(shell) {
    const scroller = shell.querySelector('.koro-nav-scroll .tiles-menu');
    const leftBtn = shell.querySelector('.koro-nav-arrow.left');
    const rightBtn = shell.querySelector('.koro-nav-arrow.right');
    if (!scroller || !leftBtn || !rightBtn) return;

    const getStep = () => Math.min(Math.round(scroller.clientWidth * 0.7), 420);

    const update = () => {
      const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      const hasOverflow = max > 2;
      shell.classList.toggle('koro-nav--overflow', hasOverflow);

      const leftDisabled = scroller.scrollLeft <= 1;
      const rightDisabled = scroller.scrollLeft >= (max - 1);

      leftBtn.classList.toggle('is-disabled', leftDisabled || !hasOverflow);
      rightBtn.classList.toggle('is-disabled', rightDisabled || !hasOverflow);

      leftBtn.disabled = leftDisabled || !hasOverflow;
      rightBtn.disabled = rightDisabled || !hasOverflow;
    };

    leftBtn.addEventListener('click', () => {
      scroller.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    rightBtn.addEventListener('click', () => {
      scroller.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    scroller.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', () => requestAnimationFrame(update));

    update();
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor live reload
  document.addEventListener('shopify:section:load', init);
})();
